import { Field } from '@playbooks/ui/components/field';
import { Link } from '@playbooks/ui/components/link';

const LegalDisclaimer = () => {
	// Render
	return (
		<Field className='block py-4 text-center'>
			<small className='block text-sm font-light text-foreground-body'>
				I agree to the{' '}
				<Link variant='link' href='/terms' className='inline h-auto p-0 font-inherit text-inherit underline'>
					Terms of Service
				</Link>{' '}
				and{' '}
				<Link variant='link' href='/privacy' className='inline h-auto p-0 font-inherit text-inherit underline'>
					Privacy Policy
				</Link>
				.
			</small>
		</Field>
	);
};
export { LegalDisclaimer };
